/** ISO 13616 national IBAN lengths (incl. country code + check digits). */
const IBAN_LENGTH_BY_COUNTRY: Record<string, number> = {
  AD: 24,
  AE: 23,
  AL: 28,
  AT: 20,
  AZ: 28,
  BA: 20,
  BE: 16,
  BG: 22,
  BH: 22,
  BR: 29,
  BY: 28,
  CH: 21,
  CR: 22,
  CY: 28,
  CZ: 24,
  DE: 22,
  DK: 18,
  DO: 28,
  EE: 20,
  EG: 29,
  ES: 24,
  FI: 18,
  FO: 18,
  FR: 27,
  GB: 22,
  GE: 22,
  GI: 23,
  GL: 18,
  GR: 27,
  GT: 28,
  HR: 21,
  HU: 28,
  IE: 22,
  IL: 23,
  IS: 26,
  IT: 27,
  JO: 30,
  KW: 30,
  KZ: 20,
  LB: 28,
  LC: 32,
  LI: 21,
  LT: 20,
  LU: 20,
  LV: 21,
  MC: 27,
  MD: 24,
  ME: 22,
  MK: 19,
  MR: 27,
  MT: 31,
  MU: 30,
  NL: 18,
  NO: 15,
  PK: 24,
  PL: 28,
  PS: 29,
  PT: 25,
  QA: 29,
  RO: 24,
  RS: 22,
  SA: 24,
  SE: 24,
  SI: 19,
  SK: 24,
  SM: 27,
  TN: 24,
  TR: 26,
  UA: 29,
  VA: 22,
  VG: 24,
  XK: 20,
};

const BIC_REGEX = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export function normalizeIban(input: string): string {
  return input.replace(/\s/g, '').toUpperCase();
}

export function normalizeBic(input: string): string {
  return input.replace(/\s/g, '').toUpperCase();
}

function ibanMod97(iban: string): boolean {
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  let expanded = '';
  for (const c of rearranged) {
    const code = c.charCodeAt(0);
    if (code >= 48 && code <= 57) {
      expanded += c;
    } else if (code >= 65 && code <= 90) {
      expanded += String(code - 55);
    } else {
      return false;
    }
  }
  let remainder = 0;
  for (let i = 0; i < expanded.length; i++) {
    remainder = (remainder * 10 + parseInt(expanded[i]!, 10)) % 97;
  }
  return remainder === 1;
}

export function isValidIban(input: string): boolean {
  const iban = normalizeIban(input);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) return false;
  if (iban.length < 15 || iban.length > 34) return false;
  const cc = iban.slice(0, 2);
  const expected = IBAN_LENGTH_BY_COUNTRY[cc];
  if (expected !== undefined && iban.length !== expected) return false;
  return ibanMod97(iban);
}

export function isValidBic(input: string): boolean {
  const bic = normalizeBic(input);
  if (bic.length !== 8 && bic.length !== 11) return false;
  return BIC_REGEX.test(bic);
}
